import { render, staticRenderFns } from "./AI_Dashboard.html?vue&type=template&id=23a23b5a&scoped=true&external"
import script from "./AI_Dashboard.js?vue&type=script&lang=js&external"
export * from "./AI_Dashboard.js?vue&type=script&lang=js&external"
import style0 from "./AI_Dashboard.scss?vue&type=style&index=0&id=23a23b5a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a23b5a",
  null
  
)

export default component.exports